export default "assets/icon-play-adeb961f.svg";